// 全局页面JS加载模块入口

// import './databus'

// import './YCF_Plugin'

// （先不用）加载全局组件，待vue-cli改造完成后将全局组件都搬到packages里面引用
// import packages from '@/packages'
// let Vue = window.Vue
// Vue.use(packages)

var renderParams = function renderParams(h, page) {
  return h('div', [h(page), h('ycf-level-change')]);
};
export { renderParams };